import { Helmet } from 'react-helmet';

const SEO = ({ 
    title = "Yassine Bazgour",
    description = "AI and Machine Learning Engineer specializing in deep learning, computer vision, and web development. 30+ projects in AI/ML, robotics, and web applications.",
    image = "https://yassinebazgour.vercel.app/og-image.jpg",
    url = "https://yassinebazgour.vercel.app",
    type = "website"
}) => {

    const structuredData = {
        "@context": "https://schema.org",
        "@type": "Person",
        "name": "Yassine Bazgour",
        "jobTitle": "AI Engineer & Full Stack Developer",
        "description": "AI and Data Science student specializing in machine learning, deep learning, and web development",
        "url": "https://yassinebazgour.vercel.app",
        "image": "https://yassinebazgour.vercel.app/og-image.jpg",
        "sameAs": [
            "https://www.linkedin.com/in/yassine-bazgour-178b73305/",
            "https://github.com/DarttGoblin",
            "https://www.kaggle.com/yassinebazgour",
            "https://www.upwork.com/freelancers/~014ea0be5b11a41ad3"
        ],
        "alumniOf": {
            "@type": "EducationalOrganization",
            "name": "Faculty of Science Semlalia"
        },
        "knowsAbout": [
            "Machine Learning",
            "Deep Learning", 
            "Computer Vision",
            "Natural Language Processing",
            "Web Development",
            "Robotics"
        ],
        "address": {
            "@type": "PostalAddress",
            "addressLocality": "Marrakech",
            "addressCountry": "Morocco"
        }
    };

    return (
        <Helmet>
            {/* Basic Meta Tags */}
            <title>{title}</title>
            <meta name="description" content={description} />
            <link rel="canonical" href={url} />
            
            {/* Open Graph (Facebook, LinkedIn) */}
            <meta property="og:type" content={type} />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:image" content={image} />
            <meta property="og:image:width" content="1200" />
            <meta property="og:image:height" content="630" />
            <meta property="og:image:alt" content={`${title} - Portfolio Preview`} />
            <meta property="og:url" content={url} />
            <meta property="og:site_name" content="Yassine Bazgour Portfolio" />
            
            {/* Twitter Card */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:image" content={image} />
            
            {/* Additional SEO */}
            <meta name="robots" content="index, follow" />
            <meta name="author" content="Yassine Bazgour" />
            <meta name="keywords" content="AI Engineer, Machine Learning, Deep Learning, Full Stack Developer, Python, React, Computer Vision, NLP, Morocco, Marrakech" />

            <script type="application/ld+json">
                {JSON.stringify(structuredData)}
            </script>
        </Helmet>
    );
};

export default SEO;